import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { GoogleData } from '../../services/GoogleData/GoogleData';

@Component({
    selector: 'book-popover',
    templateUrl: './book-popover.html',
    styleUrls: ['./book-popover.css', './book-popover.mobile.css'],
    encapsulation: ViewEncapsulation.None
})
export class BookPopoverComponent implements OnInit {
    @Input() book:any;
    googleId:string;
    isLoading:boolean = true;
    bookData:any;
    hidePercentComplete:boolean = true;
    googleData:GoogleData;

    constructor(googleData:GoogleData) {
        this.googleData = googleData;
    }
    
    async ngOnInit() {
        this.googleId = this.book.googleId;
        if (this.book.googleId) {
            var book = await this.googleData.getBook(this.book.googleId)
            this.isLoading = false;
            this.bookData = book;
        } else {
            this.bookData = this.book;
        }
    }      
 }


// WEBPACK FOOTER //
// ./web/static/components/book-popover/book-popover.ts